<template>
  <div style="background-color: white;height: 100vh;">
    <div id="l-map" style="width: 0;height: 0;"></div>
    <div v-if="editAddress">
      <!-- <div v-if="data">
      <van-address-edit :area-list="areaList" show-delete show-set-default show-search-result
        :area-columns-placeholder="['请选择', '请选择', '请选择']" @save="onSave" @delete="onDelete" :address-info="AddressInfo" />
    </div>
    <van-address-edit v-else :area-list="areaList" show-set-default show-search-result
      :area-columns-placeholder="['请选择', '请选择', '请选择']" @save="onSave" /> -->
      <!-- :rules="[{ required: true }]" -->
      <van-form @submit="onSave" style="padding: 2rem 1rem; background-color: #fff;">
        <div style="display: flex;flex-direction: row;">
          <div style="flex:1">
            <span class="title"> 收货人</span>
            <van-field v-model="AddressInfo.name" placeholder="请输入姓名"
              style="border-radius: 2rem; background-color: #f8f8f8;margin-bottom: 1rem;margin-top: 0.5rem;" />
          </div>
        </div>
        <div>
          <div style="flex:1;margin-left: 0.5rem;">
            <span class="title">手机号码</span>
            <div
              style="border-radius: 2rem; background-color: #f8f8f8;margin-bottom: 1rem;margin-top: 0.5rem; display: flex;flex-direction: row;">
              <span
                style="height: 3rem;line-height: 3rem;margin-left: 1rem;padding-bottom: 0.1rem;font-size: 0.9rem;">+86</span>
              <van-field v-model="AddressInfo.tel" placeholder="请输入手机号码" style=" background-color: #00000000; " />
              <!-- :rules="[{ required: true }, { pattern: pattern, message: '手机号码格式错误！' }]" -->
            </div>
          </div>
        </div>
        <!-- <div>
        <span class="title"> 城市/街道</span>
        <van-field id="suggestId" v-model="AddressInfo.addressD" placeholder="请输入后选择"
          style=" border-radius: 2rem; background-color: #f8f8f8;margin-bottom: 1rem;margin-top: 0.5rem;">
        </van-field>
      </div> -->
        <div>
          <span class="title"> 选择省市区</span>
          <van-field v-model="AddressInfo.addressD" placeholder="请选择省市区" readonly @click="showSelect"
            style=" border-radius: 2rem; background-color: #f8f8f8;margin-bottom: 1rem;margin-top: 0.5rem;">
          </van-field>
        </div>
        <div @click="showAddress">
          <div class="title">选择地址</div>

          <!-- <div class="selece2" v-if="AddressInfo.addressDetail">
            <div>{{ AddressInfo.addressDetail }}</div>
            <div><van-icon name="arrow" /></div>
          </div>
          <div v-else class="selece2">
            <div>选择收货地址</div>
            <div><van-icon name="arrow" /></div>
          </div> -->
          <van-field @click="showAddress" :readonly="true" v-model="AddressInfo.addressDetail" placeholder="请选择收货地址"
            style="border-radius: 1rem; background-color: #f8f8f8;margin-bottom: 1rem;margin-top: 0.5rem;" />
        </div>
        <div style="margin-top: 0.5rem;">
          <div class="title">门牌号</div>
          <van-field v-model="addressDetail" placeholder="填写详细地址，例：1号楼302"
            style="border-radius: 1rem; background-color: #f8f8f8;margin-bottom: 1rem;margin-top: 0.5rem;" />
        </div>
        <div id="searchResultPanel" style="border: 1px solid #c0c0c0;width: 100%;height: 3rem;display: none;"></div>
        <div style="font-size: 0.8rem;margin-top: 2rem;">
          <van-checkbox v-model="AddressInfo.isDefault" checked-color="#D33B2E" icon-size="1rem">设为默认地址</van-checkbox>
        </div>
        <div>
          <van-button class="foot-btn">保存</van-button>
        </div>
      </van-form>
      <van-popup v-model="show" round :style="{ height: '37%', width: '90%' }">
        <van-area title="请选择省市区" :area-list="areaList" value="110101" @confirm="confirm" @cancel="cancel" />
      </van-popup>
    </div>
    <div v-else class="parentContainer">
      <div style="padding: 1rem;">
        <span class="title">{{ AddressInfo.address }}</span>
        <van-field ref="field" v-model="tMapLocalSearchKeywords" placeholder="请输入地址并且选择"
          style="border-radius: 2rem; background-color: #f8f8f8;margin-top: 0.5rem;" />
      </div>
      <div v-if="addressList" class="addressList">
        <div v-for="(item, index) in addressList" :key="index" 
             :class="['addressItem', { firstAddress: item.isCustom }]" 
             @click="selectAddress(item)">
          <div class="item-title">
            {{ item.name }}
            <span v-if="item.isCustom" class="custom-tag">自定义</span>
          </div>
          <div class="address">{{ item.address }}</div>
        </div>
      </div>
    </div>
    <!-- 地址搜索 -->
    <LocalSearchComponent
      :address="this.tMapCenterAddress"
      :keywords="this.tMapLocalSearchKeywords"
      :onLocalSearchComplete="handleSearchComplete"
    />
  </div>
</template>
<script>
import area from "../../lip/area";
import LocalSearchComponent from '@/components/map/LocalSearch.vue';
import { reverseGeocoder } from '../../utils/TMapUtils.js';
export default {
  name: "",
  props: {},
  data() {
    return {
      show: false,
      // 选择时出现的地区
      userId: '',
      areaList: area,
      AddressInfo: {},
      data: null,
      pattern: /^(?:(?:\+|00)86)?1\d{10}$/,
      autocomplete: null,
      local: null,
      map: null,
      addressList: [],
      checked: false,
      editAddress: true,
      addressDetail: '',
      tMapCenterAddress: '', // 天地图初始化中心点
      tMapLocalSearchKeywords: '', // 检索关键字
    };
  },
  components: { LocalSearchComponent, },
  methods: {
    async selectAddress(item) {
      console.log('选择的地址信息item', item);
      try {
        // 检查所选地址是否与当前省市区匹配
        const include = this.AddressInfo.addressD.includes(item.address);
        if (!include) {
          // 省市区与选择的不一致,弹窗确认
          this.showDialog(item);
        } else {
          //解析坐标(包括自定义地址),逗号分割
          if (item.lonlat && item.lonlat.includes(',')) {
            const [lng, lat] = item.lonlat.split(',');
            this.AddressInfo.lng = lng || '';
            this.AddressInfo.lat = lat || '';
          } else {
            this.AddressInfo.lng = '';
            this.AddressInfo.lat = '';
          }
          this.AddressInfo.addressDetail = item.name;
          this.editAddress = true;
          this.$Toast.success('地址选择成功');
        }
      } catch (error) {
        this.handleError('地址处理失败，请重试');
      }
    },

    showDialog(item) {
      this.$Dialog.confirm({
        title: "地址确认",
        message: '所选地址与省市区不匹配，如果继续将替换当前省市区信息。确定要继续吗？',
        confirmButtonText: '确定使用',
        cancelButtonText: '取消'
      }).then(() => {
        // 确认使用所选地址
        this.updateAddressInfo(item);
      }).catch(() => {
      });
    },

    async updateAddressInfo(item) {
      try {
        // 天地图地址，有经纬度，使用逆地理编码
        const location = await reverseGeocoder(item.lonlat);
        const addressComponent = location.addressComponent;
        //直辖市的市名称空,采用省名称
        let cityName = addressComponent.city || addressComponent.province;
        this.AddressInfo.addressD = addressComponent.province + cityName + addressComponent.county;
        this.AddressInfo.city = addressComponent.province;
        this.AddressInfo.district = cityName;
        this.AddressInfo.address = addressComponent.county;
        this.AddressInfo.lng = location.location.lon;
        this.AddressInfo.lat = location.location.lat;
        this.AddressInfo.addressDetail = item.name;

        this.editAddress = true;
        this.$Toast.success('地址更新成功');
      } catch (err) {
        this.handleError('地址更新失败，请重试');
      }
    },

    cancel() {
      this.show = false
    },
    showSelect() {
      this.show = true
    },
    async showAddress() {
      if (!this.AddressInfo.addressD) {
        this.$Toast('请先选择省市区');
        return;
      }
      
      try {
        // 将当前省市区设置为地图中心点
        this.tMapCenterAddress = this.AddressInfo.addressD;
        
        // 根据已有地址初始化搜索
        if (this.AddressInfo.addressDetail) {
          this.tMapLocalSearchKeywords = this.AddressInfo.addressDetail;
        } else {
          this.tMapLocalSearchKeywords = '';
        }
        
        this.editAddress = false;
        
        this.$nextTick(() => {
          this.$refs.field && this.$refs.field.focus();
        });
      } catch (error) {
        this.handleError('无法加载地址选择界面');
      }
    },
    confirm(val) {
      this.AddressInfo.addressD = ''
      val.forEach((element, index) => {
        this.AddressInfo.addressD = this.AddressInfo.addressD + element.name
        this.tMapCenterAddress = this.AddressInfo.addressD;
        if (index == 0) {
          this.AddressInfo.city = element.name
        } else if (index == 1) {
          this.AddressInfo.district = element.name
          this.AddressInfo.cityCode = element.code
        } else {
          this.AddressInfo.address = element.name
        }

      });
      this.show = false
    },
    // 返回
    goback() {
      this.$router.back();
    },

    onSave() {
      var timer = setInterval(() => {
        this.onSaveAddress()
        clearInterval(timer);
      }, 500)
    },
    validatePhoneNumber(phoneNumber) {
      if (!phoneNumber) {
        return false;
      }
      if (phoneNumber.length !== 11) {
        return false;
      }
      var reg = /^1\d{10}$/;
      return reg.test(phoneNumber);
    },

    isEmp(str) {
      if (!str) {
        return true;
      }
      if (str == undefined || str == '') {
        return true;
      }
    },
    // 校验地址信息是否完整
    validateAddressInfo() {
      if (this.isEmp(this.AddressInfo.name)) {
        this.$Toast('请输入姓名');
        return false;
      }
      
      let result = this.validatePhoneNumber(this.AddressInfo.tel);
      if (!result) {
        this.$Toast('请输入正确格式手机号');
        return false;
      }
      
      if (this.isEmp(this.AddressInfo.addressD)) {
        this.$Toast('请选择省市区');
        return false;
      }
      
      if (this.isEmp(this.AddressInfo.addressDetail)) {
        this.$Toast('填写城市街道时，选择下拉具体地址');
        return false;
      }
      
      if (this.isEmp(this.addressDetail)) {
        this.$Toast('请填写详细地址');
        return false;
      }
      
      return true;
    },
    // 保存的事件
    onSaveAddress() {
      // 验证地址信息
      if (!this.validateAddressInfo()) {
        return;
      }

      // 准备请求参数
      let args = {
        recipient: this.AddressInfo.name,
        recipientMobile: this.AddressInfo.tel,
        defaultFlag: this.AddressInfo.isDefault ? "1" : "0",
        address: this.AddressInfo.addressDetail,
        houseNum: this.addressDetail,
        lat: this.AddressInfo.lat || '', // 允许为空
        lng: this.AddressInfo.lng || '', // 允许为空
        addressPname: this.AddressInfo.address,
        addressCname: this.AddressInfo.city,
        addressCCode: this.AddressInfo.cityCode,
        addressQname: this.AddressInfo.district,
        userId: this.userId,
        status: '1'
      };
      
      // 对于修改操作，添加ID参数
      if (this.data) {
        args.id = this.AddressInfo.id;
        
        // 调用蛋叔修改地址API
        this.$api.updateAddress(args)
          .then((res) => {
            this.$Toast(res.msg);
            if (res.code == 0) { // 成功
              this.goback();
            }
          })
          .catch((err) => {
            this.$Toast.fail('修改失败，请重试');
          });
      } else {
        // 新增地址
        this.$api.addAddress(args)
          .then((res) => {
            this.$Toast(res.msg);
            if (res.code == 0) { // 成功
              this.goback();
            }
          })
          .catch((err) => {
            this.$Toast.fail('保存失败，请重试');
          });
      }
    },
    
    // 地图POI搜索完成回调
    handleSearchComplete(results) {
      // 处理搜索结果
      // 如果没有搜索关键字，直接返回空列表
      if (!this.tMapLocalSearchKeywords) {
        this.addressList = [];
        return;
      }
      
      // 创建自定义地址元素
      const customAddress = {
        name: this.tMapLocalSearchKeywords,
        address: this.AddressInfo.addressD,
        lonlat: ",",
        isCustom: true // 标记为自定义地址
      };
      
      // 情况1: 没有搜索结果，显示自定义元素
      if (!results || results.length === 0) {
        this.addressList = [customAddress];
        return;
      }
      
      // 情况2: 检查搜索结果中是否有匹配的地址
      // 检查是否有地址名称与关键字匹配且省市区与当前省市区匹配的
      const hasMatchingAddress = results.some(item => {
        const nameMatch = item.name && item.name === this.tMapLocalSearchKeywords;
        const addressMatch = this.AddressInfo.addressD && item.address && 
                             this.AddressInfo.addressD.includes(item.address);
        return nameMatch && addressMatch;
      });
      
      // 如果没有匹配的地址，添加自定义元素到列表首位
      if (!hasMatchingAddress) {
        this.addressList = [customAddress, ...results];
      } else {
        // 有匹配的地址，直接使用天地图返回的结果
        this.addressList = results;
      }
    },

    handleError(message) {
      this.$Toast.fail(message);
    },

  },
  mounted() {
    // 加载地址数据（编辑模式）
    if (localStorage.getItem("addressId")) {
      this.data = JSON.parse(localStorage.getItem("addressId"));
      // 初始化地址信息
      this.AddressInfo = {
        id: this.data.id,
        name: this.data.recipient,
        tel: this.data.recipientMobile,
        isDefault: this.data.defaultFlag == "1" ? true : false,
        addressDetail: this.data.address,
        lat: this.data.lat || '',
        lng: this.data.lng || '',
        address: this.data.addressPname,
        city: this.data.addressCname,
        cityCode: this.data.addressCCode,
        district: this.data.addressQname,
        addressD: this.data.addressCname + this.data.addressQname + this.data.addressPname
      };
      
      // 设置门牌号
      this.addressDetail = this.data.houseNum || '';
      
      // 设置中心地址，用于地图初始化
      this.tMapCenterAddress = this.AddressInfo.addressD;
      
      localStorage.removeItem("addressId");
    } else {
      // 新增模式
      // 初始化默认值
      this.AddressInfo = {
        name: '',
        tel: '',
        isDefault: false,
        addressDetail: '',
        lat: '',
        lng: '',
        address: '',
        city: '',
        cityCode: '',
        district: '',
        addressD: ''
      };
    }
    
    // 获取用户ID
    if (localStorage.getItem("userInfo")) {
      this.userId = JSON.parse(localStorage.getItem("userInfo")).id;
    }
  },
  computed: {},
  watch: {},
  destroyed() {
    // 一般写在页面卸载或组件卸载的生命周期
    // this.virtualKeyboard.onEnd()
  },


};
</script>

<style lang='scss' scoped>
.van-switch--on {
  background-color: red;
}

.foot-btn {
  width: 100%;
  margin-top: 3rem;
  height: 3rem;
  border-radius: 2rem;
  line-height: 3rem;
  font-size: 1.2rem;
  background-image: linear-gradient(left, #ffc585 0%, #d59a54 100%);
  color: #f5f5f5;
  text-align: center;
}

.title {
  margin-left: 0.5rem;
  font-weight: 600;
  font-size: 0.9rem;
}

.van-cell {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 0.8rem 1.1rem;
  overflow: hidden;
  color: #323233;
  font-size: 1rem;
  line-height: 6.4vw;
  background-color: #fff;
}

.select {
  display: flex;
  flex-direction: row;
  height: 2rem;

  .selece2 {
    display: flex;
    margin-left: 3rem;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid #AAA;
    flex: 1;
    color: #666;
  }
}

.addressList {
  padding: 0.5rem;
  flex-grow: 1; /* 占据剩余空间 */
  overflow-y: scroll;

  .addressItem {
    border-bottom: 0.5px solid #eee;
    padding: 0.4rem;

    .item-title {
      display: flex;
      align-items: center;
      
      .custom-tag {
        font-size: 0.7rem;
        color: white;
        background-color: #1989fa;
        border-radius: 0.5rem;
        padding: 0 0.3rem;
        margin-left: 0.5rem;
        height: 1.2rem;
        line-height: 1.2rem;
      }
    }

    .address {
      color: #808080;
      font-size: 0.85rem;
    }
  }
  .firstAddress {
    background-color: #c6e0f7; /* 浅蓝色背景 */
    font-weight: bold;
  }
}
.parentContainer {
  display: flex;
  flex-direction: column;
  height: 100vh; /* 视口高度 */
}
</style>